import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'

import type { ItemsOrderResponse, BuyAgainItems } from '../types/SearchDropdown'

export const useGetOrders = (searchTerm: string) => {
  const [searchOrders, setSearchOrders] = useState<BuyAgainItems[]>()

  useEffect(() => {
    const request = async () => {
      const { data }: { data: ItemsOrderResponse[] } =
        await axios.get('/api/getOrders')

      if (!data) return

      const itemsOrders = data
        ?.map((item) => item?.data?.customerOrder?.items)
        .flat()

      const itemsOrdersFormated = itemsOrders?.map(({ name, detailUrl }) => ({
        text: name,
        link: detailUrl,
      }))

      setSearchOrders(itemsOrdersFormated)
    }

    request()
  }, [])

  const itemsOrdersTerm = useMemo(() => {
    const filteredOrders = searchOrders?.filter((item) => {
      return item?.text?.toLowerCase()?.includes(searchTerm.toLowerCase())
    })

    if (!filteredOrders || (filteredOrders && filteredOrders?.length <= 0)) {
      return
    }

    return filteredOrders.slice(0, 5)
  }, [searchTerm, searchOrders])

  return { itemsOrdersTerm }
}
